import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,loaddat,beginMn,filter_fn} from '../utils.js'
import UniTreeTable from '../cmp/UniTreeTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

let findDlg=false

function CatGoodsList({data=undefined,actions,choice=false}){

    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData
    //const [hiden, setHiden] = useState(true)

    if(wndData!==''&&wndData.ierarc===undefined) wndData.ierarc=1

    const context=useContext(dataContext)
    const Data=context.data['catGoods']
    const DataFld=context.data['fldGoods']
    const selUnitType=context.data['selUnitType']
    const selGoodType=context.data['selGoodType']
    const selExcise=context.data['selExcise']
    const catDepartments=context.data['catDepartments']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const getSettings=context.getSettings
    const setSettings=context.setSettings
    const usersettings=getSettings()
    const inputCols=context.inputCols
    const setLoginData=context.setLoginData
    const glStatus=context.status
    let balance=undefined
    if(wndData) balance=wndData.balance
    let hiden=true
    if(wndData.hiden!==undefined) hiden=wndData.hiden
    const setHiden=d=>setWndData({...wndData,hiden:d})

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'catGoods',sortable:false},
        {caption:'id',minWidth:'20',maxWidth:'65',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'100',dataId:'name',sortable:true},
        {caption:localestr('Вид'),minWidth:'30',maxWidth:'75',dataId:'type_g',sortable:true},
        {caption:localestr('Од.'),minWidth:'30',maxWidth:'45',dataId:'unit',sortable:true},
        {caption:localestr('Штрихкод'),minWidth:'75',maxWidth:'115',dataId:'barcode',sortable:true},
        {caption:localestr('Залишок'),minWidth:'32',maxWidth:'75',dataId:'sum_bal',sortable:true},
        {caption:localestr('Закупка'),minWidth:'32',maxWidth:'75',dataId:'sum_in',sortable:true},
        {caption:localestr('Націнка'),minWidth:'32',maxWidth:'75',dataId:'sum_up',sortable:true},
        {caption:localestr('Продаж'),minWidth:'32',maxWidth:'75',dataId:'sum_out',sortable:true},
        {caption:localestr('Акційна ціна'),minWidth:'32',maxWidth:'75',dataId:'sum_spec',sortable:true},
        {caption:localestr('УКТЗЕД'),minWidth:'85',maxWidth:'95',dataId:'uktz',sortable:true},
        {caption:localestr('Акциз'),minWidth:'50',dataId:'excise',sortable:true},
        {caption:localestr('В меню'),minWidth:'47',maxWidth:'48',dataId:'is_menu',typeCol:'check'},
        {caption:localestr('Назва меню'),minWidth:'100',dataId:'menu_name',sortable:true},
        {caption:localestr('Підрозділ'),minWidth:'70',dataId:'department',sortable:true},
        {caption:localestr('Розлив'),minWidth:'50',maxWidth:'55',dataId:'koef',sortable:true},
        {caption:localestr('Порядок'),minWidth:'68',maxWidth:'68',dataId:'sort',sortable:true},
        {caption:localestr('Калькуляція'),minWidth:'68',maxWidth:'68',dataId:'has_calc',typeCol:'check'},
        {caption:localestr('Не виготовляти'),minWidth:'68',maxWidth:'68',dataId:'without_production',typeCol:'check'},
        {caption:localestr('Фіскальний апарат'),minWidth:'70',dataId:'fiscal',sortable:true},
        {caption:localestr('Доступно гостю'),minWidth:'47',maxWidth:'48',dataId:'guest_enable',typeCol:'check'},
        {caption:localestr('Доступно на доставку'),minWidth:'47',maxWidth:'48',dataId:'online_enable',typeCol:'check'},
        {caption:localestr('Категорія меню'),minWidth:'70',dataId:'menu_cat',sortable:true},
    ]

    if(usersettings.CatGoodsList&&usersettings.CatGoodsList.cols){
        for(let i=0;i<usersettings.CatGoodsList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatGoodsList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    } else {
        cols[3].hiden=true
        cols[5].hiden=true
        cols[7].hiden=true
        cols[8].hiden=true
        cols[10].hiden=true
        cols[11].hiden=true
        cols[12].hiden=true
        cols[14].hiden=true
        cols[15].hiden=true
        cols[16].hiden=true
        cols[17].hiden=true
        cols[18].hiden=true
        cols[19].hiden=true
        cols[20].hiden=true
        cols[21].hiden=true
        cols[22].hiden=true
        cols[23].hiden=true
    }

    const filterData=[ //+
        {caption:'id',dataId:'id',typeVal:'text'},
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'},
        {caption:localestr('Вид'),dataId:'type_g',typeVal:'selGoodType'},
        {caption:localestr('Од.виміру'),dataId:'unit',typeVal:'selUnitType'},
        {caption:localestr('Штрихкод'),dataId:'barcode',typeVal:'text'},
        {caption:localestr('Ціна закупки'),dataId:'sum_in',typeVal:'number'},
        {caption:localestr('Націнка'),dataId:'sum_up',typeVal:'number'},
        {caption:localestr('Ціна продажу'),dataId:'sum_out',typeVal:'number'},
        {caption:localestr('Акційна ціна'),dataId:'sum_spec',typeVal:'number'},
        {caption:localestr('Залишок'),dataId:'sum_bal',typeVal:'number'},
        {caption:localestr('УКТЗЕД'),dataId:'uktz',typeVal:'text'},
        {caption:localestr('Акциз'),dataId:'excise',typeVal:'selExcise'},
        {caption:localestr('Меню'),dataId:'is_menu',typeVal:'selYN'},
        {caption:localestr('Фіскальний апарат'),dataId:'fiscal',typeVal:'catDevices'},
        {caption:localestr('Назва меню'),dataId:'menu_name',typeVal:'text'},
        {caption:localestr('Підрозділ'),dataId:'department',typeVal:'catDepartments'},
        {caption:localestr('Додатково друкувати'),dataId:'department2',typeVal:'catDepartments'},
        {caption:localestr('Заборонити знижки'),dataId:'disable_discount',typeVal:'selYN'},
        {caption:localestr('Є калькуляція'),dataId:'has_calc',typeVal:'selYN'},
        {caption:localestr('Не виготовляти'),dataId:'without_production',typeVal:'selYN'},
        {caption:localestr('Доступно гостю'),dataId:'guest_enable',typeVal:'selYN'},
        {caption:localestr('Доступно на доставку'),dataId:'online_enable',typeVal:'selYN'},
        {caption:localestr('Категорія меню'),dataId:'menu_cat',typeVal:'catMenuGrp'},
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        let ierarc=1
        if(showAFilter) ierarc=0
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(!showAFilter) setWndData({...wndData,ierarc,filter:undefined,showAFilter})
        else setWndData({...wndData,ierarc,showAFilter})
    }

    const calculate=ingr=>{
        let sum=0
        for(let j=0;j<ingr.length;j++){
            if(ingr[j].type>1) continue
            const good_id=ingr[j].good
            const idx=Data.findIndex((it)=>it.id===good_id)
            if(idx!==-1) sum+=parseFloat(Data[idx].sum_in||0)*parseFloat(ingr[j].qtt||0)
        }
        if(!sum) return ''
        return sum.toFixed(2)
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        let balance=[]
        if(wndData.balance) balance=wndData.balance
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item,sum_spec:item.special_price,good_type:parseInt(item.type),type_g:selGoodType.find(x => x.value === item.type),
                sum_bal:'',unit:selUnitType.find(x => x.value === item.unit),excise:selExcise.find(x => x.value === item.excise),has_calc:'0',allergens:(item.allergens?item.allergens.split(','):[])}
            if (currentCol && currentCol.id===item.id && currentCol.isfolder===item.isfolder) setCurrCol(newItem)
            const idx=balance.findIndex(x => x.good === parseInt(item.id))
            if(idx!==-1) {
                newItem.sum_bal=balance[idx].qtt===0?'':balance[idx].qtt.toFixed(3)
                newItem.title=null
                for(let i=0;i<balance[idx].deps.length;i++){
                    let idx2=-1
                    const dep=balance[idx].deps[i]
                    let acc=''
                    if(dep.acc==='281') acc=' ('+localestr('товар')+')'
                    if(dep.acc==='260') acc=' ('+localestr('продукція')+')'
                    if(dep.acc==='250') acc=' ('+localestr('нанівфабрикат')+')'
                    if(catDepartments) idx2=catDepartments.findIndex(x=>parseInt(x.id)===dep.dep)
                    if(idx2!==-1){
                        if(newItem.title) newItem.title+="\n"+catDepartments[idx2].name+' :  '+dep.qtt+' '+(newItem.unit||{name:''}).name+acc
                        else newItem.title=catDepartments[idx2].name+' :  '+dep.qtt+' '+(newItem.unit||{name:''}).name+acc
                    } else {
                        if(newItem.title) newItem.title+="\n"+dep.dep+' :  '+dep.qtt+' '+(newItem.unit||{name:''}).name+acc
                        else newItem.title=''+dep.dep+' :  '+dep.qtt+' '+(newItem.unit||{name:''}).name+acc
                    }
                }
            }
            if(item.ingr) newItem.sum_in=calculate(item.ingr)
            if(item.ingr) newItem.has_calc='1'
            const sum_out=parseFloat(newItem.sum_out)||0
            const sum_in=(parseFloat(newItem.sum_in)||0)*(parseFloat(newItem.koef)||1)
            if(sum_out && sum_in) newItem.sum_up=((sum_out-sum_in)*100/sum_in).toFixed(1)+'%'
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col.substring(0,4)==='sum_') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({CatGoodsList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const newItem=()=>{tabNew('catGoods_edit',localestr('Товар')+' *',{type:1,unit:1,parent:wndData.currentFld,update:after_save})}

    const editItem=(d)=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) {
                let item=DataFld.find(el=>el.id===wndData.currentCol.id)
                if(!item) item=wndData.currentCol

                loaddat('action=fldGoodsImg&data='+item.id,(d)=>{
                    const status=d.status
                    if(status==='UsrChoise') {setLoginData(d);return}
                    if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                    if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                    tabNew('fldGoods_edit',localestr('Папка')+' '+toText(wndData.currentCol['name']),{...item,...d.data,update:after_save})
                })
            }
            else {
                loaddat('action=catGoodsImg&data='+wndData.currentCol.id,(d)=>{
                    const status=d.status
                    if(status==='UsrChoise') {setLoginData(d);return}
                    if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                    if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
                    tabNew('catGoods_edit',localestr('Товар')+' '+(wndData.currentCol.id||'')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,...d.data,update:after_save})
                })
            }
        }
    }

    const copyItem=()=>{
        let item={...wndData.currentCol,ingr:[],changed:true}
        delete item.id
        delete item.price_history
        delete item.price_history_out
        const now=new Date()
        now.setUTCHours(0,0,0,0)
        const currDate=now.toISOString().split('.')[0]+'Z'
        if(item.sum_in&&item.type!=='2'&&item.type!=='3') item.register_in=[{act:'set', date:currDate,olddate:undefined,value:item.sum_in}]
        if(item.sum_out) item.register_out=[{act:'set', date:currDate,olddate:undefined,value:item.sum_out}]
        if(item.modifiers){
            for(let i=0; i<item.modifiers.length; i++){
                const new_mod={...item.modifiers[i],edit:true}
                delete new_mod.id
                if(new_mod.child){
                    for(let k=0; k<new_mod.child.length; k++){
                        const new_child={...new_mod.child[k],edit:true}
                        delete new_child.id
                        new_mod.child[k]=new_child
                    }
                }
                item.modifiers[i]=new_mod
            }
        }
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) tabNew('fldGoods_edit',localestr('Папка')+' *',{...item,update:after_save})
            else tabNew('catGoods_edit',localestr('Товар')+' *',{...item,update:after_save})
            //console.log(wndData.currentCol)
        }
    }

    const fldClick=(fld,ch=1)=>{
        let flt=wndDataFld.find(el=>el.parent.id===fld.id)
        if(!flt) flt=wndData.list.find(el=>el.parent.id===fld.id)
        else flt.isfolder=true
        if(!wndData.currentFld) setWndData({...wndData,currentFld:fld,currentCol:flt})
        else if(wndData.currentFld.id===fld.id&&ch===0) setWndData({...wndData,currentFld:fld.parent,currentCol:flt})
        else setWndData({...wndData,currentFld:fld,currentCol:flt})
        setGlData({needFocus:0})
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder&&choice===3&&((wndData.currentFld&&wndData.currentFld.id!==wndData.currentCol.id)||!wndData.currentFld)){
                msg(localestr('Додати всі товари з папки?'),localestr('Товари'),[{caption:localestr('Так'),action:()=>tabChoice(wndData.currentCol)},{caption:localestr('Ні'),action:()=>fldClick(wndData.currentCol,0)}])
                //tabChoice(wndData.currentCol)
            }
            else if(wndData.currentCol.isfolder) fldClick(wndData.currentCol,0)
            else if(choice===2||choice===3) tabChoice(wndData.currentCol)
            else if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
       
    const getNextItem=(i,d)=>{
        if(d>0) for(let idx=i+1;idx<wndData.list.length;idx++) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})
        else for(let idx=i-1;idx>=0;idx--) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})

        return undefined
    }

    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            const idx=wndData.list.findIndex(el=>el.id===wndData.currentCol.id)
            let item=undefined
            if(hiden&&idx+1>=wndData.list.length&&idx>0) item=getNextItem(idx,-1)
            else if(hiden&&idx>0) item=getNextItem(idx,1)
            else if(idx!==-1) item={...wndData.list[idx]}
            let newData={status:'rem',key:(wndData.currentCol.isfolder?'FldGoods':'CatGoods'),data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='1'?'0':'1')}}
            saveData(newData,()=>{setWndData({...wndData,currentCol:item})})
        }
    }

    const transferItem=(item,target)=>{
        if (typeof item === 'object') {
            let newData={status:'mod',key:(item.isfolder?'FldGoods':'CatGoods'),data:{...item,parent:target,colour:item.colour ? item.colour.src : null,sorting:item.sort,allergens:item.allergens?item.allergens.toString().substring(0, 50):null}}
            saveData(newData,()=>{})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol,currentFld:currentCol.parent})
        setGlData({needFocus:0})
    }

    const filterHndl=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        let ierarc=1
        if(fltr) ierarc=0
        if(showFilter) ierarc=wndData.ierarc
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter,ierarc})
        else{
            setWndData({...wndData,showFilter,filter,ierarc,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:'catGoods'}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            const type=wndData.currentCol.isfolder?'fldGoods':'catGoods'
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }

    const parent_check=(wndDataFld,parentId,checkId)=>{
        if(parentId===checkId) return true
        const par=wndDataFld.find(el=>el.id===parentId)
        if(!par) return false
        if(!par.parent) return false
        if(par.parent.id===checkId) return true
        if(!par.parent.parent) return false
        if(par.parent.parent.id===checkId) return true
        if(!par.parent.parent.parent) return false
        if(par.parent.parent.parent.id===checkId) return true
        if(!par.parent.parent.parent.parent) return false
        if(par.parent.parent.parent.parent.id===checkId) return true
        if(!par.parent.parent.parent.parent.parent) return false
        if(par.parent.parent.parent.parent.parent.id===checkId) return true
        return false
    }

    /*const filter_check=(wndFilterData,item)=>{
        if(!wndFilterData) return true
        let ret=true
        for (let k in wndFilterData){
            const val1=item[wndFilterData[k].dataId]
            const val2=wndFilterData[k].value
            const comp=wndFilterData[k].compare
            const dataId=wndFilterData[k].typeVal
            if (comp==='='){
                if (dataId.substring(0, 3)==='sel') ret=val1.value===val2||val1===val2 //value
                else if (dataId.substring(0, 3)==='cat') ret=val1.id===val2.id //id
                else if (dataId==='text') ret=val1.toLowerCase()===val2.toLowerCase()
                else if (dataId==='number') ret=parseFloat(val1)===parseFloat(val2)
                else ret=val1===val2
            }
            else if (comp==='<>'){
                if (dataId.substring(0, 3)==='sel') ret=val1.value!==val2.value //value
                else if (dataId.substring(0, 3)==='cat') ret=val1.id!==val2.id //id
                else if (dataId==='text') ret=val1.toLowerCase()!==val2.toLowerCase()
                else if (dataId==='number') ret=parseFloat(val1)!==parseFloat(val2)
                else ret=val1!==val2
            }
            else if (comp==='lk'){
                ret=val1.toLowerCase().includes(val2.toLowerCase())
            }
            else if (comp==='nlk'){
                ret=!val1.toLowerCase().includes(val2.toLowerCase())
            }
            else if (comp==='>'){
                ret=val1>val2
            }
            else if (comp==='<'){
                ret=val1<val2
            }
            else {
                ret=false
            }
            if (!ret) break
        }
        return ret
    }*/

    const grpEdit=()=>{
        let list=[...wndData.list||[]]
        if(wndData.ierarc){
            const wndDataFld = typeof DataFld === 'undefined' ? [] : DataFld
            if(wndData.currentFld){
                list=list.filter(el=>parent_check(wndDataFld,el.parent.id,wndData.currentFld.id))
            } 
        }
        //list=list.filter(el=>filter_check(wndData.filter,el))
        list=list.filter(el=>filter_fn(el,wndData.filter))
        list=list.map(el=>{return{...el,checked:true}})
        const fields=[
            {caption:localestr('Назва'),minWidth:'160',dataId:'name'},
            {caption:localestr('Папка'),minWidth:'80',dataId:'pid',typeVal:'fldGoods'},
            {caption:localestr('Вид'),minWidth:'80',dataId:'type',typeVal:'selGoodType'},
            {caption:localestr('Од.виміру'),minWidth:'40',dataId:'unit',typeVal:'selUnitType'},
            {caption:localestr('Ціна закупки'),minWidth:'45',dataId:'sum_in',typeVal:'irgGoods'},
            {caption:localestr('Вид акцизу'),minWidth:'50',dataId:'excise',typeVal:'selExcise'},
            {caption:localestr('УКТЗЕД'),minWidth:'90',dataId:'uktz',typeVal:'text'},
            {caption:localestr('Звільнено від ПДВ'),minWidth:'90',dataId:'no_vat',typeVal:'selYN'},
            {caption:localestr('Додати в меню'),minWidth:'45',dataId:'is_menu',typeVal:'selYN'},
            {caption:localestr('Місце приготування'),minWidth:'80',dataId:'department',typeVal:'catDepartments'},
            {caption:localestr('Додатково друкувати'),minWidth:'80',dataId:'department2',typeVal:'catDepartments'},
            {caption:localestr('Фіскальний апарат'),minWidth:'40',dataId:'fiscal',typeVal:'catDevices'},
            {caption:localestr('Ціна продажу'),minWidth:'45',dataId:'sum_out',typeVal:'irgMenu'},
            {caption:localestr('Доступно гостю'),minWidth:'45',dataId:'guest_enable',typeVal:'selYN'},
            {caption:localestr('Доступно на доставку'),minWidth:'45',dataId:'online_enable',typeVal:'selYN'},
            {caption:localestr('Категорія'),minWidth:'40',dataId:'menu_cat',typeVal:'catMenuGrp'},
            {caption:localestr('Розлив на порцію'),minWidth:'40',dataId:'koef',typeVal:'number'},
            {caption:localestr('Порядок'),minWidth:'28',dataId:'sorting',typeVal:'number'},
            {caption:localestr('Позначка на видалення'),minWidth:'45',dataId:'marked',typeVal:'selYN'},
            {caption:localestr('Заборонити знижки'),minWidth:'45',dataId:'disable_discount',typeVal:'selYN'},
            {caption:localestr('Не виготовляти'),minWidth:'45',dataId:'without_production',typeVal:'selYN'},
        ]
        //addTWnd(localestr('Групова зміна'),'serv_grp_edit',undefined,{dataType:'catMenu',list,fields})
        tabNew('serv_grp_edit',localestr('Групова зміна товарів'),{dataType:'catGoods',list,fields,checked:true})
    }

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if(status==='UsrChoise') {setLoginData(d);return}
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            wndData=actions.getWndData()
            setWndData({...wndData,balance:d.data})
        } else {
            if(glStatus==='loading') return
            if(glStatus==='UsrChoise') return
            loaddat('action=balGoods',(dt)=>{loadData(dt)})
        }
    }

    const after_save=(d)=>{
        if(!d) return
        const currentCol={}
        currentCol.id=''+d.id
        if(d.isfolder) currentCol.isfolder=true
        wndData=actions.getWndData()
        let currentFld=wndData.currentFld
        if(d.parent) currentFld=DataFld.find(el=>el.id===d.parent.id)
        if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
        //console.log({...wndData,currentCol,currentFld})
        setTimeout(()=>{setWndData({...wndData,currentCol,currentFld});setGlData({needFocus:0})},10)
        updateData('catGoods')
        loadData()
    }

    const tick=()=>{
        if (wndData?.showFilter) return
        if (typeof Data === 'undefined') {setTimeout(()=>loadData(),300);return;}
        loadData()
    }

    const repSupplies=()=>{
        const to=new Date()
        let data=undefined
        if(wndData.currentCol && wndData.currentCol.isfolder) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'in_f',value:wndData.currentCol}],
            grouping:[{name:'Товар',value:'good_id',checked:true,type:'catGoods'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldGoods'},
                {name:'Контрагент',value:'counterpartie_id',checked: false,type: 'catCounterparties'},
                {name:'Підрозділ',value:'department_id',checked: true,type: 'catDepartments'},
                {name:'Автор',value:'author_id',checked: false,type: 'catUsers'},
                {name:'Тип товару',value:'g_type',checked: false,type: 'selGoodType'},
                {name:'Одиниці',value:'unit',checked: false,type: 'selUnitType'},
                {name:'Дата',value:'date',checked: false,type: 'date'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document'}],
            from:beginMn(to),to:to,run:true}
        else if(wndData.currentCol) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'=',value:wndData.currentCol}],
            grouping:[{name:'Товар',value:'good_id',checked:false,type:'catGoods'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldGoods'},
                {name:'Контрагент',value:'counterpartie_id',checked: false,type: 'catCounterparties'},
                {name:'Підрозділ',value:'department_id',checked: true,type: 'catDepartments'},
                {name:'Автор',value:'author_id',checked: false,type: 'catUsers'},
                {name:'Тип товару',value:'g_type',checked: false,type: 'selGoodType'},
                {name:'Одиниці',value:'unit',checked: false,type: 'selUnitType'},
                {name:'Дата',value:'date',checked: false,type: 'date'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document'}],
            from:beginMn(to),to:to,run:true}
        tabNew('repSupplies',localestr('Звіт з поступлень'),data,true)
    }

    const repSales=()=>{
        const to=new Date()
        let data=undefined
        if(wndData.currentCol && wndData.currentCol.isfolder) data={
            filter:[{caption:'Меню',dataId:'menu_id',typeVal:'catGoods',compare:'in_f',value:wndData.currentCol}],
            grouping:[{name:localestr('Меню'),value:'menu_id',checked:true,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Зал'),value:'hall_id',checked:false,type:'catHalls'},
                {name:localestr('Стіл'),value:'table_id',checked:false,type:'catTables'},
                {name:localestr('Підрозділ'),value:'department_id',checked:false,type:'catDepartments'},
                {name:localestr('Автор'),value:'author_id',checked:true,type:'catUsers'},
                {name:localestr('Знижка'),value:'discount_id',checked:false,type:'catDiscounts'},
                {name:localestr('Тип оплати'),value:'payType',checked:true,type:'selPayTypes'},
                {name:localestr('Тип акцизу'),value:'excise',checked:false,type:'selExcise'},
                {name:localestr('РРО'),value:'fiscal_id',checked:false,type:'catDevices'},
                {name:localestr('Дата'),value:'date_doc',checked:false,type:'date'},
                {name:localestr('Документ'),value:'doc_id',checked:true,type:'docOrder'}],
            from:beginMn(to),to:to,run:true}
        else if(wndData.currentCol) data={
            filter:[{caption:'Меню',dataId:'menu_id',typeVal:'catGoods',compare:'=',value:wndData.currentCol}],
            grouping:[{name:localestr('Меню'),value:'menu_id',checked:false,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Зал'),value:'hall_id',checked:false,type:'catHalls'},
                {name:localestr('Стіл'),value:'table_id',checked:false,type:'catTables'},
                {name:localestr('Підрозділ'),value:'department_id',checked:false,type:'catDepartments'},
                {name:localestr('Автор'),value:'author_id',checked:true,type:'catUsers'},
                {name:localestr('Знижка'),value:'discount_id',checked:false,type:'catDiscounts'},
                {name:localestr('Тип оплати'),value:'payType',checked:true,type:'selPayTypes'},
                {name:localestr('Тип акцизу'),value:'excise',checked:false,type:'selExcise'},
                {name:localestr('РРО'),value:'fiscal_id',checked:false,type:'catDevices'},
                {name:localestr('Дата'),value:'date_doc',checked:false,type:'date'},
                {name:localestr('Документ'),value:'doc_id',checked:true,type:'docOrder'}],
            from:beginMn(to),to:to,run:true}
        tabNew('repSales',localestr('Звіт з продаж'),data,true)
    }

    const repReturn=()=>{
        const to=new Date()
        let data=undefined
        if(wndData.currentCol && wndData.currentCol.isfolder) data={
            filter:[{caption:'Меню',dataId:'menu_id',typeVal:'catGoods',compare:'in_f',value:wndData.currentCol}],
            grouping:[{name:localestr('Меню'),value:'menu_id',checked:true,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Зал'),value:'hall_id',checked:false,type:'catHalls'},
                {name:localestr('Стіл'),value:'table_id',checked:false,type:'catTables'},
                {name:localestr('Підрозділ'),value:'department_id',checked:false,type:'catDepartments'},
                {name:localestr('Автор'),value:'author_id',checked:true,type:'catUsers'},
                {name:localestr('Знижка'),value:'discount_id',checked:false,type:'catDiscounts'},
                {name:localestr('Тип оплати'),value:'payType',checked:true,type:'selPayTypes'},
                {name:localestr('Тип акцизу'),value:'excise',checked:false,type:'selExcise'},
                {name:localestr('Причина'),value:'reason_id',checked:true,type:'catReasons'},
                {name:localestr('Дата'),value:'date_doc',checked:false,type:'date'},
                {name:localestr('Документ'),value:'doc_id',checked:true,type:'docOrder'}],
            from:beginMn(to),to:to,run:true}
        else if(wndData.currentCol) data={
            filter:[{caption:'Меню',dataId:'menu_id',typeVal:'catGoods',compare:'=',value:wndData.currentCol}],
            grouping:[{name:localestr('Меню'),value:'menu_id',checked:false,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Зал'),value:'hall_id',checked:false,type:'catHalls'},
                {name:localestr('Стіл'),value:'table_id',checked:false,type:'catTables'},
                {name:localestr('Підрозділ'),value:'department_id',checked:false,type:'catDepartments'},
                {name:localestr('Автор'),value:'author_id',checked:true,type:'catUsers'},
                {name:localestr('Знижка'),value:'discount_id',checked:false,type:'catDiscounts'},
                {name:localestr('Тип оплати'),value:'payType',checked:true,type:'selPayTypes'},
                {name:localestr('Тип акцизу'),value:'excise',checked:false,type:'selExcise'},
                {name:localestr('Причина'),value:'reason_id',checked:true,type:'catReasons'},
                {name:localestr('Дата'),value:'date_doc',checked:false,type:'date'},
                {name:localestr('Документ'),value:'doc_id',checked:true,type:'docOrder'}],
            from:beginMn(to),to:to,run:true}
        tabNew('repReturn',localestr('Звіт по відмовах'),data,true)
    }

    const repStock=()=>{
        const to=new Date()
        let data=undefined
        if(wndData.currentCol && wndData.currentCol.isfolder) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'in_f',value:wndData.currentCol}],
            grouping:[{name:localestr('Товар'),value:'good_id',checked:true,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Підрозділ'),value:'department_id',checked:true,type:'catDepartments'},
                {name:localestr('Тип товару'),value:'g_type',checked:false,type:'selGoodType'},
                {name:localestr('Документ'),value:'doc_id',checked:false,type:'document'},
                {name:localestr('Куди-Звідки'),value:'from_to',checked:false,type:'catalog',disable_move:true}],
            from:beginMn(to),to:to,run:true}
        else if(wndData.currentCol) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'=',value:wndData.currentCol}],
            grouping:[{name:localestr('Товар'),value:'good_id',checked:false,type:'catGoods'},
                {name:localestr('Група'),value:'folder_id',checked:false,type:'fldGoods'},
                {name:localestr('Підрозділ'),value:'department_id',checked:true,type:'catDepartments'},
                {name:localestr('Тип товару'),value:'g_type',checked:false,type:'selGoodType'},
                {name:localestr('Документ'),value:'doc_id',checked:true,type:'document'},
                {name:localestr('Куди-Звідки'),value:'from_to',checked:false,type:'catalog',disable_move:true}],
            from:beginMn(to),to:to,run:true}
        tabNew('repStock',localestr('Звіт про залишки'),data,true)
    }

    const repCalcs=()=>{
        const to=new Date()
        let data=undefined
        if(wndData.currentCol && wndData.currentCol.isfolder) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'in_f',value:wndData.currentCol}],
            grouping:[{name:'Продукція',value:'p_good_id',checked:true,type:'catGoods'},
                {name:'Група прод.',value:'p_folder_id',checked: false,type: 'fldGoods'},
                {name:'Товар',value:'good_id',checked:true,type:'catGoods'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldGoods'},
                {name:'Автор',value:'author_id',checked: false,type: 'catUsers'},
                {name:'Тип товару',value:'g_type',checked: false,type: 'selGoodType'},
                {name:'Одиниці',value:'unit',checked: false,type: 'selUnitType'},
                {name:'Дата',value:'date',checked: false,type: 'date'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document'}],
            to:to,run:true}
        else if(wndData.currentCol) data={
            filter:[{caption:'Товар',dataId:'good_id',typeVal:'catGoods',compare:'=',value:wndData.currentCol}],
            grouping:[{name:'Продукція',value:'p_good_id',checked:true,type:'catGoods'},
                {name:'Група прод.',value:'p_folder_id',checked: false,type: 'fldGoods'},
                {name:'Товар',value:'good_id',checked:false,type:'catGoods'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldGoods'},
                {name:'Автор',value:'author_id',checked: false,type: 'catUsers'},
                {name:'Тип товару',value:'g_type',checked: false,type: 'selGoodType'},
                {name:'Одиниці',value:'unit',checked: false,type: 'selUnitType'},
                {name:'Дата',value:'date',checked: false,type: 'date'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document'}],
            to:to,run:true}
        tabNew('repCalcs',localestr('Звіт по калькуляціях'),data,true)
    }


    const findItem=(val)=>{
        const newData={...wndData,findText:val}
        findDlg=false
        newData.findArr=null
        if (val.length>1){
            const Arr=wndData.list.filter(el=>(el.id.indexOf(val)===0||
            (el.name||'').toLowerCase().indexOf(val.toLowerCase())!==-1||
            (el.barcode&&el.barcode.indexOf(val)===0)||
            (el.marks&&val.length>8&&el.marks.findIndex(it=>it===val)!==-1))&&!parseInt(el.marked))
            if(Arr.length>10) Arr.splice(10)
            newData.findArr=Arr
            if(Arr.length) findDlg=true
            else{newData.findArr=null;findDlg=false}
        }
        setWndData(newData)
    }

    const findClick=(el)=>{
        const wndData_=actions.getWndData()
        const newData={...wndData_,currentCol:{...el},currentFld:{...el.parent},findText:'',findArr:null,currFind:-1}
        findDlg=false
        setWndData(newData)
        setGlData({needFocus:0})
    }

    const keyHandler=(e)=>{
        if(e.key==='ArrowUp'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.currFind===-1) setWndData({...wndData,currFind:0})
            else if(wndData.currFind===0) setWndData({...wndData,currFind:wndData.findArr.length-1})
            else setWndData({...wndData,currFind:wndData.currFind-1})
        }
        else if(e.key==='ArrowDown'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.findArr.length-1<=wndData.currFind) setWndData({...wndData,currFind:0})
            else setWndData({...wndData,currFind:wndData.currFind+1})
        }
        else if(e.key==='Enter'&&wndData.findArr&&wndData.currFind!==-1) {
            if(wndData.currFind===-1) findClick(wndData.findArr[0])
            else findClick(wndData.findArr[wndData.currFind])
        }
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='shift_Insert') tabNew('fldGoods_edit',localestr('Папка')+' *')
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filterHndl()
        //else console.log(key)
    }

    const hDragDrop=(item,target)=>{
        if(item.isfolder && item.id===target.id) return
        if(item.parent.id===target.id) return
        if(item.id===target.parent.id) return
        if(target.parent.parent) {
            if(item.id===target.parent.parent.id) return
            if(target.parent.parent.parent) {
                if(item.id===target.parent.parent.parent.id) return
                if(target.parent.parent.parent.parent) {
                    if(item.id===target.parent.parent.parent.parent.id) return
                    
                }
            }
        }
        msg('Перемістити '+item.name+' у '+target.name+'?',localestr('Переміщення'),[{caption:localestr('Так'),action:()=>{transferItem(item,target)}},{caption:localestr('Ні'),action:()=>{}}])
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        //console.log('effect1')
        if (typeof Data === 'undefined') getData('catGoods')
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data,DataFld,balance])

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof catDepartments === 'undefined') getData('catDepartments')
        tick()
        if(wndData.currentCol&&choice) setGlData({needFocus:0})
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])


    let wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    if(hiden) wndDataList=wndDataList.filter(item=>!parseInt(item.marked))
    let wndDataFld = typeof DataFld === 'undefined' ? [] : DataFld
    if(hiden) wndDataFld=wndDataFld.filter(item=>!parseInt(item.marked))
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filterHndl}/> : ''  //+
    const ierarcBtn = wndData.ierarc ? <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати список')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:0})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:0})}}
                                    ><img src={icon+'#foldBut'} alt={localestr('Показувати список')} /></div> : 
                                    <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати папки')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:1})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:1})}}
                                    ><img src={icon+'#unfoldBut'} alt={localestr('Показувати папки')} /></div>

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filterHndl},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData('catGoods')}},
        {name:localestr('Групова зміна'),icon:'#hisBut',action:grpEdit},
    ]
    if(hiden) menuData.push({name:localestr('Показати видалені'),icon:'#remBut',action:()=>setHiden(false)})
    if(!hiden) menuData.push({name:localestr('Сховати видалені'),icon:'#remBut',action:()=>setHiden(true)})
    if(choice) menuData.splice(2,3)
    if(choice) menuData.splice(3,1)

    const repData=[
        {name:localestr('Прихід'),icon:'#b230',action:repSupplies},
        {name:localestr('Продажі'),icon:'#b230',action:repSales},
        {name:localestr('Відмови'),icon:'#b230',action:repReturn},
        {name:localestr('Залишки'),icon:'#b230',action:repStock},
        {name:localestr('Де використовується'),icon:'#b230',action:repCalcs},
    ]

    let findItems=null
    if(findDlg&&wndData.findArr){
        setTimeout(()=>findDlg=false,30000)
        const items=wndData.findArr.map((el,idx)=>{
            let stl={cursor:'pointer',fontSize:'small'}
            if(idx===wndData.currFind) stl.background='#9E91F7'
            return(
            <div key={idx} style={stl} onClick={()=>{findClick(el)}}>{el.id+' - '+el.name}</div>
        )})
        findItems=<div className='no-print' style={{right:'0px',top:'24px',width:'100%',position:'absolute',background:'#FFFFFF',zIndex:'100'}}>
            {items}
        </div>
    }
    
    return(
        <>
        
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати папку')+' (Shift+Ins)'} 
            onClick={()=>{tabNew('fldGoods_edit',localestr('Папка')+' *',{parent:wndData.currentFld,update:after_save})}}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('fldGoods_edit',localestr('Папка')+' *',{parent:wndData.currentFld,update:after_save})}}><img src={icon+'#fldBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>editItem()} onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}
            ><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={removeItem} onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}
            ><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}} onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}
            ><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            {ierarcBtn}
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div style={{position:'relative',padding:'3px'}}>
                <input id='search' type='text' value={wndData.findText||''} onChange={(e)=>{findItem(e.target.value)}} onKeyUp={keyHandler}
                    onBlur={()=>{setTimeout(()=>{if(findDlg) setWndData({...wndData,findArr:null,currFind:undefined})},200)}} placeholder={localestr('пошук')} 
                    style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'7px',top:'9px',width:'14px',height:'14px',opacity:0.5}}/>
                {findItems}
            </div>

            <div style={{flexGrow:'10'}}></div>

            <Menu data={repData}><div tabIndex='0' style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'95px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                <img style={{width:'24px',height:'24px',verticalAlign:'middle',paddingRight:'8px'}} src={icon+'#rep'} alt={localestr('Звіти')} />&nbsp;
                {localestr('Звіти')}
            </div></Menu>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTreeTable haveHeader={true} colsArr={cols} data={wndDataList} folders={wndDataFld} ierarc={wndData.ierarc} currCol={wndData.currentCol} currFld={wndData.currentFld} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} Caption={localestr('Товари')} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} fldHandle={fldClick} openHandle={editClick} keyHandle={anyKey} hDragDrop={hDragDrop} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} isActive={isActive()}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatGoodsList